var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17707 6.34894C8.27034 6.34894 8.36362 6.31333 8.43485 6.24213L9.16401 5.51298C9.30643 5.37055 9.30643 5.13984 9.16401 4.99744C9.02158 4.85502 8.79087 4.85502 8.64847 4.99744L7.91932 5.7266C7.77689 5.86903 7.77689 6.09974 7.91932 6.24213C7.99048 6.31336 8.08379 6.34894 8.17707 6.34894Z",
    fill: "url(#paint0_linear_383_9726)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1068 4.99744L7.91932 7.18494C7.77689 7.32737 7.77689 7.55808 7.91932 7.70047C7.99052 7.77167 8.08383 7.80728 8.1771 7.80728C8.27038 7.80728 8.36366 7.77167 8.43489 7.70047L10.6224 5.51298C10.7648 5.37055 10.7648 5.13984 10.6224 4.99744C10.48 4.85502 10.2492 4.85502 10.1068 4.99744Z",
    fill: "url(#paint1_linear_383_9726)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.51 3.23338C18.1225 2.45829 17.343 1.97656 16.4759 1.97656H9.41102C8.05822 1.97656 6.76702 2.55618 5.86823 3.56735L2.44473 7.41827C1.67237 8.28663 1.24718 9.40496 1.25001 10.6141L1.86002 15.3195C1.94724 15.9938 2.26026 16.6304 2.74134 17.1111C3.32639 17.696 4.10412 18.0183 4.93167 18.0183H17.2914C18.0959 18.0182 18.75 17.3642 18.75 16.5599V4.25023C18.75 3.89917 18.667 3.54742 18.51 3.23338ZM4.08193 8.87124L7.50489 5.0207C7.98911 4.47632 8.68442 4.16406 9.41255 4.16406H16.4764C16.5102 4.16406 16.5383 4.18115 16.5625 4.25023V9.99739H3.4667C3.53366 9.61144 3.72055 9.27856 4.08193 8.87124ZM16.9271 15.1015H3.8021C3.60058 15.1015 3.43751 14.9385 3.43751 14.7369C3.43751 14.5354 3.60058 14.3724 3.8021 14.3724H16.9271C17.1286 14.3724 17.2917 14.5355 17.2917 14.737C17.2917 14.9385 17.1286 15.1015 16.9271 15.1015ZM16.9271 12.914H14.7396C14.5381 12.914 14.375 12.751 14.375 12.5494C14.375 12.3479 14.5381 12.1849 14.7396 12.1849H16.9271C17.1286 12.1849 17.2917 12.3479 17.2917 12.5494C17.2916 12.751 17.1286 12.914 16.9271 12.914Z",
    fill: "url(#paint2_linear_383_9726)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_9726",
    x1: 7.8125,
    y1: 5.61978,
    x2: 9.27083,
    y2: 5.61978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_9726",
    x1: 7.8125,
    y1: 6.34895,
    x2: 10.7292,
    y2: 6.34895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_383_9726",
    x1: 1.25,
    y1: 9.99741,
    x2: 18.75,
    y2: 9.99741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.28dad6476661e6f048d231be0673e573.svg";
export { ForwardRef as ReactComponent };